import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@/app/services/auth.service';

@Component({
    standalone: true,
    selector: 'app-quick-actions-widget',
    imports: [RouterLink],
    template: `
        <div class="card flex flex-col gap-3">
            <span class="font-semibold text-lg">Quick actions</span>
            @if (isGlobal()) {
                <a
                    routerLink="/website/new"
                    class="flex items-center gap-3 p-3 rounded border border-surface-200 dark:border-surface-700 hover:border-primary hover:text-primary no-underline text-current"
                >
                    <i class="pi pi-globe"></i>
                    <span class="text-sm">Add Website</span>
                </a>
                <a
                    routerLink="/companies"
                    [queryParams]="{ action: 'add' }"
                    class="flex items-center gap-3 p-3 rounded border border-surface-200 dark:border-surface-700 hover:border-primary hover:text-primary no-underline text-current"
                >
                    <i class="pi pi-building"></i>
                    <span class="text-sm">Add Company</span>
                </a>
                <a
                    routerLink="/game-templates"
                    [queryParams]="{ action: 'add' }"
                    class="flex items-center gap-3 p-3 rounded border border-surface-200 dark:border-surface-700 hover:border-primary hover:text-primary no-underline text-current"
                >
                    <i class="pi pi-th-large"></i>
                    <span class="text-sm">Add Game Template</span>
                </a>
            } @else {
                <p class="text-sm text-muted-color m-0">
                    Creating websites, companies, and game templates requires a
                    global admin account.
                </p>
            }
        </div>
    `,
})
export class QuickActionsWidget {
    private readonly authService = inject(AuthService);

    protected readonly isGlobal = this.authService.isGlobalAdmin;
}
